module.exports = __webpack_public_path__ + "static/img/working.3a9ae6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joinln/working.jpg
// module id = QTfB
// module chunks = 3